import { createContext } from "react";

export const InventariosCabContext = createContext()
export const InventariosCabFormContext = createContext()
export const InventariosCabReportContext = createContext()